import React from 'react';

const FeatureList = () => {
  return (
    <ul className="w-full flex flex-col items-start gap-2 text-lg max-md:text-sm">
      <li>
        <span className="text-sivarbet-primary">✔</span>
        {' '}
        Un diseño fluido para navegar por nuestros juegos.
      </li>
      <li>
        <span className="text-sivarbet-primary">✔</span>
        {' '}
        Tiempos cortos de espera entre cada acción.
      </li>
      <li>
        <span className="text-sivarbet-primary">✔</span>
        {' '}
        Puede seguir en vivo los puntajes de cada partido.
      </li>
      <li>
        <span className="text-sivarbet-primary">✔</span>
        {' '}
        Con mucha frecuencia ofrecemos ofertas exclusivas por la App.
      </li>
      <li>
        <span className="text-sivarbet-primary">✔</span>
        {' '}
        Puede realizar depósitos y retiros con mucha más facilidad.
      </li>
    </ul>
  );
};

export default FeatureList;
